"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.todos.completed': 'Completed',
    'tutorial.todos.pending': 'Pending',
    'tutorial.todos.markCompleted': 'Mark as completed',
    'tutorial.todos.markPending': 'Mark as pending',
    'tutorial.todos.statusDone': 'done',
    'tutorial.todos.statusUndone': 'not done',
    'tutorial.todos.changeComment.1': 'You changed the status of the task "{name}" to: {status}.',
    'tutorial.todos.changeComment.2': 'Task "{name}" – {status}. Noted.',
    'tutorial.todos.changeComment.3': 'I noted the change: the task "{name}" is now {status}.',
    'tutorial.todos.changeComment.4': 'Saved! The task "{name}" is marked as {status}.',
    'tutorial.audio.stop': 'Stop',
    'tutorial.audio.pause': 'Pause',
    'tutorial.audio.play': 'Play',
    'tutorial.audio.volume': 'Volume',
    'tutorial.audio.writingSpeed': 'Writing speed',
    'tutorial.audio.writingSpeed.normal': 'Normal',
    'tutorial.audio.writingSpeed.fast': 'Fast',
    'tutorial.audio.writingSpeed.veryFast': 'Very fast',
};
